import { UseSortByProps, useSortBy } from 'react-instantsearch';
import { INDEX_ASSETS, INDEX_GLOBAL } from '../types';

export default function CustomSortBy(props: UseSortByProps) {
  const { currentRefinement, options, refine, canRefine } = useSortBy(props);
  return (
    <>
      <select
        className="select select-bordered max-w-xs rounded-[100px] border-zinc-200 text-sm font-bold focus:outline-none"
        value={currentRefinement}
        onChange={(event) => refine(event.currentTarget.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
}
